import { Pagination, Skeleton } from '@mui/material'
import { BackpackIcon, Cross2Icon, DragHandleDots2Icon } from '@radix-ui/react-icons'
import { MoreHorizontal } from 'lucide-react'
import React, { useEffect, useState } from 'react'
import toast from 'react-hot-toast'
import { checkTagValidity } from '../../Utils/Utils'
import { DELETE_AGENT, LIST_TEAM } from '../../Utils/constant'
import { Tabs } from '../../components/Widget/Tab'
import { AddAgent } from '../../components/utilisateur/AddAgent'
import { AddTeam } from '../../components/utilisateur/AddTeam'
import { EditAgent } from '../../components/utilisateur/EditAgent'
import { deleteOne } from '../../services/service'
import { useStoreAgent } from '../../store/agentStore'
import { useStoreApp } from '../../store/storeApp'

const Agents = () => {

  const agents = useStoreAgent()
  const [active, setActive] = useState({
    index: 0,
    filter: 'COMMERCIAL',
    value: 'Commercial',
  });
  const [loading, setLoading] = useState(false);
  const [typeForm, setTypeForm] = useState('add');
  const [agentId, setAgentId] = useState("")
  const [selectItem, setSelectItem] = useState(null)
  const more = (page) => {

  }

  const role = [
    {
      index: 0,
      filter: 'COMMERCIAL',
      value: 'Commercial',
    },
    {
      index: 1,
      filter: "TECHNICIEN",
      value: 'Techniciens',
    }
  ]


  const equipe = useStoreApp()
  useEffect(() => {
    equipe.getData(LIST_TEAM, { page: 0, param: "", size: 10 }, '')
    agents.agent({ page: 0, param: "", size: 10 }, `&profile=${active.filter}`)
  }, [active.filter])
  return (
    <>
      {
        checkTagValidity('LISTE_AGENTS') ?
          <div className="">
            <div className="lg:flex gap-x-2 ">
              <h1 className="font-mtn text-3xl font-extrabold text-black mb-8">
                Agents & Equipes
              </h1>
              <div className='ml-auto'>

                <dialog id="add_user" className="modal rounded-none">
                  <div className="modal-box w-10/12 max-w-xl">
                    <div className="modal-action">
                      <h1 className='mr-auto text-2xl font-bold'> {
                        typeForm === "add" ? 'Ajouter un agent' : "Modifier l'agent"
                      }</h1>
                      <form method="dialog">
                        <button id='closeAgent' className="btn btn-sm"><Cross2Icon /></button>
                      </form>
                    </div>
                    {typeForm === "add" ? <AddAgent /> : <EditAgent item={selectItem} />}
                  </div>
                </dialog>

                <dialog id="add_Team" className="modal rounded-none">
                  <div className="modal-box w-10/12 max-w-xl h-3/5">
                    <div className="modal-action">
                      <h1 className='mr-auto text-2xl font-bold font-mtn'>
                        Ajouter une equipe
                      </h1>
                      <form method="dialog">
                        <button id='close' className="btn btn-sm"><Cross2Icon /></button>
                      </form>
                    </div>
                    <AddTeam />
                  </div>
                </dialog>

              </div>

            </div>
            <Tabs tabsData={role} active={active} setActive={setActive} />
            {
              active.index === 0 || active.index === 1 ? (
                <>
                  <div className='lg:flex items-center mt-4'>
                    <input onChange={(e) => {
                      agents.agent({ page: 0, param: e.target.value, size: 10 }, `&profile=${active.filter}`)
                    }} type="text" placeholder="Recherche..." className="input input-bordered px-3 w-80 h-10 text-gray-900 placeholder:text-gray-400"
                    />

                    {
                      checkTagValidity('AJOUTER_AGENT') ?
                        <button onClick={() => {
                          setTypeForm('add')
                          document.getElementById('add_user').showModal()
                        }
                        } className="mt-2 ml-auto btn btn-sm bg-main rounded-md text-black text-xs hover:bg-gray-900 hover:text-white" >
                          Ajouter un agent
                        </button>
                        : null
                    }

                  </div>

                  <div className='grid md:grid-cols-4 lg:grid-cols-3 xl:grid-cols-5 2xl:grid-cols-5 gap-2 my-8'>
                    {
                      agents?.data?.agents?.length === 0 ? '' : agents?.data?.agents?.length !== 0 && !agents?.loading ? (
                        agents?.data?.agents?.map((item) => (
                          <div className="bg-white shadow-sm border border-gray-200 rounded">
                            <div className="relative py-8 px-4">
                              <div className="dropdown dropdown-end absolute right-2 top-2">
                                <div
                                  tabIndex={0}
                                  role="button"
                                  className="w-8 h-8 rounded-full flex items-center justify-center bg-gray-50"
                                >
                                  <MoreHorizontal size={20} />
                                </div>
                                <ul
                                  tabIndex={0}
                                  className="mt-1 dropdown-content z-[1] menu p-2 border shadow bg-base-100 rounded-lg w-44"
                                >
                                  <button
                                    className="bg-white hover:bg-gray-100 text-gray-600 font-semibold h-9 w-full flex items-center justify-start rounded-lg px-3"
                                    onClick={() => {
                                      setTypeForm('update')
                                      setSelectItem(item)
                                      document.getElementById('add_user').showModal()
                                    }
                                    }
                                  >
                                    Modifier
                                  </button>
                                  <button
                                    onClick={() => {
                                      setAgentId(item.id)
                                      document.getElementById('disable_client').showModal()
                                    }
                                    }
                                    className="bg-white hover:bg-red-600 text-black hover:text-white font-semibold h-9 w-full flex items-center justify-start rounded-lg px-3"
                                  >
                                    Supprimer
                                  </button>

                                  <dialog id="disable_client" className="modal">
                                    <div className="modal-box max-w-md rounded-lg">
                                      <h3 className="font-extrabold text-xl text-red-600 ">
                                        Attention
                                      </h3>
                                      <p className="pt-2 text-black font-medium">
                                        Voulez vous vraiment effectuer cette action ?
                                      </p>
                                      <div className="modal-action">
                                        <form
                                          method="dialog"
                                          className="w-full flex items-center justify-end gap-x-4"
                                        >
                                          <button className="bg-gray-100 text-gray-600 w-fit h-10 px-4 rounded-md flex items-center justify-center font-semibold">
                                            Annuler
                                          </button>
                                          <button onClick={() => {
                                            deleteOne(DELETE_AGENT, agentId).then((res) => {
                                              agents.agent({ page: 0, param: "", size: 10 }, '&profile=null')
                                              toast.success('Agent supprimé')
                                            }).catch((err) => {
                                              toast.error(err.response.data.donnee)
                                            })
                                          }} className="bg-red-600 text-white w-fit h-10 px-4 rounded-md flex items-center justify-center font-semibold">
                                            Désactiver
                                          </button>
                                        </form>
                                      </div>
                                    </div>
                                  </dialog>

                                </ul>
                              </div>
                              <div className="mx-auto  bg-slate-200 w-20 h-20 rounded-full"></div>
                              <div className="text-center">
                                <h4 className="text-lg font-extrabold truncate">{item.nomPrenoms}</h4>
                                <h4 className="text-sm">{item?.profile?.split('ROLE_')}</h4>
                              </div>
                              <div className="mt-8 mb-3 space-y-3">
                                <p className="text-xs gap-2 flex"><DragHandleDots2Icon />{item.numero}</p>
                                <p className="text-xs gap-2 flex"> <BackpackIcon />{item.email}</p>
                              </div>
                              <div className="flex justify-center mt-8">
                                {/* <Link to={`intention`}>
                                  <button className='border-none hover:bg-amber-200 btn btn-sm bg-amber-200 text-slate-900'>Detail</button>
                                </Link> */}
                              </div>
                            </div>
                          </div>
                        ))
                      ) :
                        [1, 2, 3, 4].map(() => (
                          <div className="bg-white shadow-sm border border-gray-200 rounded">
                            <div className="relative py-8 px-4">

                              <div className="mx-auto  bg-slate-200 w-20 h-20 rounded-full"></div>
                              <div className="flex justify-center">
                                <div>
                                  <h4 className="text-lg font-extrabold truncate"><Skeleton className='' height={20} width={140} /></h4>
                                  <h4 className="text-sm"><Skeleton width={130} height={20} /></h4>
                                </div>

                              </div>
                              <div className="mt-8 mb-3 space-y-3">
                                <Skeleton className='text-center' width={170} />
                                <Skeleton className='text-center' width={120} />
                              </div>
                              <div className="flex justify-center mt-8">
                                <Skeleton width={70} height={30} variant='rounded' />

                              </div>
                            </div>
                          </div>
                        ))
                    }
                  </div>
                </>

              ) : null
            }

            {
              loading ? null :
                (
                  <div className='my-3 flex justify-end'>
                    <Pagination onChange={(event, newValue) => more(newValue)}
                      onSelect={selectedPage => more(selectedPage)} count={agents?.totalPages} variant="outlined" color='primary' shape="rounded" />
                  </div>
                )
            }
          </div >
          : null
      }
    </>

  )
}

export default Agents